import hourglassIcon from '../../../../../assets/image/hourglass.svg';
import {IconNameInfoCircle} from '../status1/GetNationalCardIdBottomSheet';

const ValidationsPending = () => {
  return (
    <div className="space-y-4">
      <ValidationCard title="اعتبارسنجی مزرعه" />
      <ValidationCard title="اعتبارسنجی بانکی" />

      <div className="flex gap-2 mt-4">
        <IconNameInfoCircle
          className=" h-5 w-5 !text-gray-700"
          fill="#8E949D"
        />
        <span className="text-sm font-normal text-gray-600">
          نتایج اعتبارسنجی شما تا ۱ ساعت دیگر مشخص خواهد شد و به شما اطلاع‌رسانی
          می‌شود.
        </span>
      </div>
    </div>
  );
};

export default ValidationsPending;

// -----------------------------------------------------------

export const ValidationCard = ({title}: {title?: string}) => (
  <div className="space-y-2">
    {title && (
      <span className="text-gray-800 font-Medium text-md">{title}</span>
    )}

    <div className="flex flex-col items-center justify-center h-32 gap-2 p-3 rounded-lg bg-gray-50">
      <img src={hourglassIcon} className="w-10" alt="pending image" />
      <span className="text-gray-800 text-md">در حال بررسی درخواست</span>
    </div>
  </div>
);
